module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-9.webp?60e9a2b1";